import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Output,
} from '@angular/core';
import { TransactionWrapper, Upsell } from '@core/models';

@Component({
  selector: 'app-group-outing',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage],
  templateUrl: './group-outing.component.html',
  styleUrl: './group-outing.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupOutingComponent {
  @Output() changeUpsell = new EventEmitter<HTMLInputElement>();
  totalTransactionSeats = input.required<number>();
  transaction = input.required<TransactionWrapper>();
  upsellSelected = input.required<Upsell | null>();

  onChangeUpsell(radio: HTMLInputElement) {
    this.changeUpsell.emit(radio);
  }
}
